import React, { Fragment } from 'react'
//import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import 'bootstrap/dist/css/bootstrap.min.css'

const tableStyle = {
  backgroundColor: '#ffffff',
  marginBottom: '50px',
}

class LegendAccounting extends React.Component {
  constructor(props) {
    super(props)
  }

  renderHeader() {
    return <Fragment><th key="legend" colSpan="2" style={{borderTopWidth: '0px'}}><h3>Legend</h3></th></Fragment>
  }

  renderData() {
    const myData = [].concat(Object.values(this.props.accounting.colors))
    return Object.keys(myData).map((key) => {
      const color = myData[key]
      return <tr key={key}><td>{color['description']}</td><td><div className="col-sm-6 bd-placeholder-img rounded" style={{backgroundColor: color['name'], height: '32px', width: '92px', display: 'inline-block'}}></div></td></tr>
    }
    )
  }

  renderStatistics() {
    return <Fragment><th key="legend" colSpan="4" style={{borderTopWidth: '0px'}} className="text-center"><h4>Statistics - {this.props.accounting.month}</h4></th></Fragment>
  }

  renderDataStatistics() {
    const myData = [].concat(Object.values(this.props.accounting.statistics))
    return Object.keys(myData).map((key) => {
      const stat = myData[key]
      return <Fragment key={key}><tr><th colSpan="4" className="text-center">{stat['description']}</th></tr><tr><td>Medical</td><td>Rest</td><td>Unpaid</td><td>Total</td></tr><tr><td>{stat['medical']}</td><td>{stat['rest']}</td><td>{stat['unpaid']}</td><td>{stat['total']}</td></tr></Fragment>
    }
    )
  }

  render() {
    if (this.props.accounting.colors) {
      const selectedDateString = this.props.accounting.month.split(' ').join(` ${new Date().getDay()}, `)
      const selectedDate = new Date(selectedDateString)
      const user = this.props.accounting.user
      const l = `/add_time_off/${user['id']}?month=${selectedDate.getMonth() + 1}&year=${selectedDate.getFullYear()}`
      const la = '/add_public_holidays/' + user['id']
      const ld = '/delete_public_holidays/' + user['id']

      return <div className="row"><table className="table" style={tableStyle}><tbody><tr>{this.renderHeader()}</tr>{this.renderData()}</tbody></table><table className="table table-bordered" style={tableStyle}><tbody><tr>{this.renderStatistics()}</tr>{this.renderDataStatistics()}</tbody></table><div className="col-sm-6"><a href={la} className="btn btn-secondary btn-sm col-sm-12" style={{ display: this.props.accounting.user.admin === true ? 'block' : 'none'}}>Add public holiday</a></div><div className="col-sm-6"><a href={ld} className="btn btn-secondary btn-sm col-sm-12" style={{ display: this.props.accounting.user.admin === true ? 'block' : 'none'}}>Delete public holiday</a></div><div className="col-sm-6" style={{ display: this.props.accounting.user.admin === true ? 'block' : 'none'}}><a href={l} className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}}>Add time off</a></div><div className="col-sm-6" style={{ display: this.props.accounting.user.admin === false ? 'block' : 'none'}}><a href={l} className="btn btn-secondary btn-sm col-sm-12" style={{marginTop: '10px'}}>Request time off</a></div></div>
    }
    return <div>Waiting</div>
  }
}

LegendAccounting.propTypes = {
  accounting: PropTypes.object,
}

export default LegendAccounting
